import { render, staticRenderFns } from "./MilestonesLog.vue?vue&type=template&id=4bc7c646&"
import script from "./MilestonesLog.vue?vue&type=script&lang=js&"
export * from "./MilestonesLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports